import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@ferris/react';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { ButtonType } from '@ferris/react/components/button/Button';
import TranslationUtil from '../../utils/TranslationUtil';
import { createInteractionEvent } from '../../utils/EventProviders/EgClickstreamUtil';
import { EPC_UPL_REDIRECT_URLS } from '../../constants/common';
import { UserCtx } from '../../contexts/user';

export function LoginButton(props) {
    const {
        loginText,
        isFrboFlow,
        display,
        classes,
        locale,
        isProd,
        rootPath
    } = props;

    if (!display) {
        return null;
    }

    const {
        getBasicUserInformation,
        loading
    } = useContext(UserCtx);

    const [userInformation, setUserInformation] = useState(null);
    const retrieveEpcUserInformation = async () => {
        const information = await getBasicUserInformation();
        setUserInformation(information);
    };

    const [authUrl, setAuthUrl] = useState('/');
    const getAuthUrl = () => {
        if (isFrboFlow) {
            const loginInterstitialLink = `/${locale}/${rootPath}/login-interstitial`;
            return `/login?enable_login=true&referrer_page_location=homepage&redirectTo=${loginInterstitialLink}`;
        }
        return EPC_UPL_REDIRECT_URLS(!isProd, locale, window.location.href);
    };

    const { trigger } = useContext(TrackingContext);
    const onClick = () => {
        trigger('interaction', createInteractionEvent(isFrboFlow ? 'vr_login.selected' : 'pco_login.selected', '', '', 'NavBar', isFrboFlow ? '2.4.0' : '2.4.1'));
    };

    useEffect(() => {
        retrieveEpcUserInformation();
        setAuthUrl(getAuthUrl());
    }, []);

    if (!userInformation || userInformation?.epcUserId || loading) return null;

    return (
        <a
            href={authUrl}
            onClick={onClick}
            className={classes}
            role="button"
        >
            <Button
                type={ButtonType.UTILITY}
            >
                {loginText}
            </Button>
        </a>
    );
}

LoginButton.propTypes = {
    loginText: PropTypes.string.isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    display: PropTypes.bool.isRequired,
    classes: PropTypes.string, // Optional additional classes for the button,
    locale: PropTypes.string,
    rootPath: PropTypes.string.isRequired,
    isProd: PropTypes.bool.isRequired
};

LoginButton.defaultProps = {
    // Default to an empty string for classes if not provided
    classes: '',
    locale: 'en_US'
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const {
        features, locale, rootPath
    } = app;

    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const loginText = translations.getTranslation('lyp.header.login.text');

    return {
        isFrboFlow: features.isFrboFlow,
        loginText,
        locale: locale.display,
        rootPath,
        isProd: features.isProd
    };
};

const ConnectedLoginButton = connect(mapStateToProps)(LoginButton);
export default ConnectedLoginButton;
